import { Empty, Segmented } from "antd";
import { GeneralTab } from "./GeneralTab";
import { useContext, useEffect, useState } from "react";
import { ProjectsTab } from "./ProjectsTab";
import trans from "../../../../utils";
import { popupcontext } from "../../../../context/Popupscontext";

const ViewCompany = ({
	data,
	selected,
	setSelected,
	manageProjects,
	refetch,
}) => {
	const { reloadData, setReloadData } = useContext(popupcontext);
	const renderContent = () => {
		switch (selected) {
			case "General":
				return <GeneralTab data={data} />;
			case "Projects":
				return data?.projects?.length > 0 ? (
					<ProjectsTab
						data={data}
						manageProjects={manageProjects}
						refetch={refetch}
					/>
				) : (
					<Empty description={trans("No projects assigned")} />
				);
			default:
				return null;
		}
	};
	console.log("reloaddata", reloadData);
	useEffect(() => {
		if (reloadData) {
			refetch();
			setReloadData(false);
		}
	}, [reloadData]);
	return (
		<>
			<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
				<Segmented
					options={[
						{ label: trans("General"), value: "General" },
						{ label: trans("Projects"), value: "Projects" },
					]}
					block
					value={selected}
					onChange={setSelected}
				/>

				<div style={{ marginTop: 16, flex: 1, overflowY: "auto" }}>
					{renderContent()}
				</div>
			</div>
		</>
	);
};

export default ViewCompany;
